import type { LegDTO } from '@/types/dto/agent';
import { replaceCarrier } from '@/utils/carriers';
import { cn } from '@/utils/cn';
import { Spinner, Typography } from '@packages/webshop-design-system';
import { useState, type FC } from 'react';

interface CarrierLogoProps {
  carrier: LegDTO['carrier'];
}

const CarrierLogo: FC<CarrierLogoProps> = ({ carrier }) => {
  const [isLogoLoading, setIsLogoLoading] = useState(true);

  const displayCarrier = replaceCarrier(carrier);

  if (!displayCarrier?.name && !displayCarrier?.logoUrl) {
    return null;
  }

  return (
    <div className="flex h-auto w-full items-end gap-2">
      {displayCarrier?.logoUrl && (
        <div className="relative max-w-[50%]">
          {isLogoLoading && (
            <div className="flex items-center justify-center">
              <Spinner />
            </div>
          )}
          <img
            src={displayCarrier.logoUrl}
            alt={displayCarrier.name ?? 'Carrier logo'}
            className={cn('min-h-4 min-w-4 max-w-full', {
              hidden: isLogoLoading,
            })}
            onLoad={() => setIsLogoLoading(false)}
            onError={() => setIsLogoLoading(false)}
            data-testid="ws-carrier-logo-image"
          />
        </div>
      )}
      {!!displayCarrier?.name && (
        <div className="w-fit">
          <Typography variant="body2">{displayCarrier?.name}</Typography>
        </div>
      )}
    </div>
  );
};

export default CarrierLogo;
